import { Container, Row, Col, Form, Button } from 'react-bootstrap'
// import { Recaptcha } from './../../components/General';
import Link from 'next/link';

function VflHeader() {

return (
<>
	<div className="vfl__Header pt-5">
		<Container>
			<Row>
				<Col lg={6} md={12} sm={12} className="text-center px-5">
				<h2><strong>VITALITY FOR LIFE</strong></h2>
				<h4><strong>Monthly Newsletter</strong></h4>
				<p className="pt-5 pb-2">Sign up for my FREE monthly newsletter and stay updated on my favorite wellness products, current specials and promotions and get helpful wellness tips and more.</p>
				<h4><strong>Sign up for FREE</strong></h4>
				<Form>
					<Form.Group controlId="fname" className="m-auto pb-2">
						<Form.Control type="text" placeholder="Enter your First Name" className=" rounded-0"/>
					</Form.Group>
					<Form.Group controlId="lname" className="m-auto pb-2">
						<Form.Control type="text" placeholder="Enter your Last Name" className=" rounded-0"/>
					</Form.Group>
					<Form.Group controlId="email" className="m-auto pb-2">
						<Form.Control className="form-control" type="email" placeholder="Enter your Email Address" className=" rounded-0"/>
					</Form.Group>
					<div className="vfl__Header--recaptcha d-flex justify-content-center">
						{/* <Recaptcha/> */}
					</div>
                    <Link href="/vitality-for-life-newsletter/confirmation">
						<Button variant="warning text-white font-weight-bold px-5 py-3 rounded-0 my-3">SIGN UP</Button>
                    </Link>
					<br />
					<small className="pt-1">Your information is safe with us.<br /> We'll never sell or rent your details to anyone, for any reason ever!</small>
					<p className="vfl__Header--testimonial pt-4"><em>I love your newsletters!<br />They're full of helpful info<br />and they're easy to read.<br />- Jill S.</em></p>
				</Form>
				</Col>
				<Col lg={6} md={12} sm={12}>
				<div className="vfl__Header--img">
					<img className="mr-3 mt-5 img-fluid" src="../images/vfl/img-vitality-for-life-beauty-shot.png" alt="" />
				</div>
				</Col>
			</Row>
		</Container>
	</div>
	<style jsx global>{`
		.btn{
			background: #CB2A30;
			border-bottom: 4px solid #691E19;
			font-size: 1.5rem;
		}
		.btn:hover{
			background: #d5343a;
			text-decoration: none;
			border-bottom: 4px solid #691E19;
		}
		.vfl__Header .form-group{
			max-width: 80%;
		}
			@media(max-width: 1199px){
				.vfl__Header .form-group{
					max-width:100%!important;
				}
			@media(max-width: 767px){
				.vfl__Header .container{
					max-width:100%!important;
				}
		`}
	</style>
	<style jsx>{`
		.vfl__Header{
			background: #efefef url(../images/vfl/img-hero-bg.jpg) top right no-repeat;
			background-size: auto;
			background-color: #8DB948;
		}
		.vfl__Header--testimonial{
			background: url(../images/vfl/img-quotes.png) no-repeat center;
		}
		.vfl__Header--img{
			float: right;
			position: absolute;
			right: -285px;
			bottom: 0;
			max-width: 150%;
		}
			@media(max-width: 1741px){
				.vfl__Header--img{
					right: -200px;
				}
			}
			@media(max-width: 1571px){
				.vfl__Header--img{
					right: -95px;
				}
			}
			@media(max-width: 1361px){
				.vfl__Header--img{
					right: 0px;
				}
			}
			@media(max-width: 991px){
				.vfl__Header{
					background-size: cover;
				}
				.vfl__Header--img{
					max-width: 100%;
					right: 0px;
					float: none;
					position: relative;
					margin-top: 45px;
				}
				img{
					position: relative;
					top: auto;
					max-width: 100% !important;
					height: auto;
					width: 100%;
				}
				.vfl__Header--testimonial {
					background-size: 90%;
				}
			}
		`}
	</style>
</>
);
}
export default VflHeader;